import React from 'react';
import { Coins, Landmark, Globe, BarChart3, Shield } from 'lucide-react';

const tabs = [
  { id: 'crypto', label: 'CRYPTO', icon: Coins, color: 'text-emerald-400 border-emerald-500' },
  { id: 'stocks', label: 'EQUITIES', icon: Landmark, color: 'text-blue-400 border-blue-500' },
  { id: 'etfs', label: 'ETFs', icon: BarChart3, color: 'text-cyan-400 border-cyan-500' },
  { id: 'forex', label: 'FOREX', icon: Globe, color: 'text-amber-400 border-amber-500' },
  { id: 'intangibles', label: 'IP ASSETS', icon: Shield, color: 'text-purple-400 border-purple-500' },
];

export function MarketTabSelector({ activeMarket, onSelect }) {
  return (
    <div className="flex gap-1 bg-[#090B0F] border border-white/10 p-1" data-testid="market-tab-selector">
      {tabs.map(tab => {
        const isActive = activeMarket === tab.id;
        return (
          <button key={tab.id} onClick={() => onSelect(tab.id)}
            className={`flex items-center gap-1.5 px-3 py-2 font-mono text-xs transition-all ${isActive
              ? `${tab.color} bg-white/5 border-b-2` : 'text-slate-500 hover:text-slate-300 border-b-2 border-transparent'}`}
            data-testid={`market-tab-${tab.id}`}>
            <tab.icon className="w-3.5 h-3.5" />
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}
